module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonerebranding-04@2x.b486a390.jpg";